module.exports = __webpack_public_path__ + "media/media/logos/AICPA-logo-ca89b6a61c58264c893a82ed9bace7c2.png";